import React from 'react';
import './Home.css';
import Typed from 'react-typed';
import { faFacebook, faGithub, faLinkedin, faMedium } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Home = () => {
    return (
        <div className="bg">
            <section className="headerMain">
                <div className="max-width pb-5">
                    <div className="header-content pb-5">
                        <div className="text-1">Hello, my name is</div>
                        <div className="text-2">Md Farhad Hossain</div>
                        <div className="text-3 pb-5">
                            And I'm a <span> </span>
                            <span>
                                <Typed
                                    strings={[
                                        'Full Stack Web Developer',
                                        'Creative web designer',
                                        'quick learner']}
                                    typeSpeed={50}
                                    backSpeed={60}
                                    loop >
                                </Typed>
                            </span>
                        </div>
                        <a target="_blank" href="https://drive.google.com/file/d/1gO2e5P-fBqAbuQAbV8VWy9PH0HfEVmkG/view?usp=sharing">Download CV</a>
                    </div>
                </div>
                <div className="social">
                    <ul>
                        <li><a href="https://www.linkedin.com/in/farhad-hossain-0280b8151/" target="_blank"><FontAwesomeIcon icon={faLinkedin} className="icn"></FontAwesomeIcon><span className="expand">Linkedin</span></a></li>
                        <li> <a href="https://www.facebook.com/forhad.hossain.9638718" target="_blank" className=""><FontAwesomeIcon icon={faFacebook} className="icn"></FontAwesomeIcon><span className="expand">Facebook</span></a></li>
                        <li><a href="https://github.com/Farhad16" target="_blank" className=""><FontAwesomeIcon icon={faGithub} className="icn"></FontAwesomeIcon><span className="expand">Github</span></a></li>
                        <li><a href="https://medium.com/@fhossain389" target="_blank" className=""><FontAwesomeIcon icon={faMedium} className="icn"></FontAwesomeIcon><span className="expand">Medium</span></a></li>
                    </ul>
                </div>
            </section>

        </div>
    );
};

export default Home;